export default __webpack_public_path__ + "static/media/pancake.3e56ca43.png";